import "./NotificationBanner.scss";
import React from "react";
import { useSelector } from "react-redux";
import { RootState, useThunkDispatch } from "../../store";
import { dismissBanner } from "../../store/app/actions";
import { Alert } from "@mui/material";
import { Markdown } from "../components";

export const NotificationBanner: React.FC = React.memo(function NotificationBanner() {
    const banner = useSelector((state: RootState) => state.app.banner);
    const dispatch = useThunkDispatch();

    const onDismiss = React.useCallback(() => {
        dispatch(dismissBanner());
    }, [dispatch]);

    if (!banner) return null;

    return (
        <Alert
            className="Qerent-notification-banner"
            severity={banner.severity}
            onClose={onDismiss}
        >
            <Markdown source={banner.content} />
        </Alert>
    );
});